/**
 * Route for `campaign-description`. Registered via createRoute; root wires into router.tsx.
 */
import { createRoute } from "@tanstack/react-router";
import { rootRoute } from "../routes/__root";
import { CampaignDescriptionPage } from "../features/campaign-description/CampaignDescriptionPage";

export const campaignDescriptionRoute = createRoute({
	getParentRoute: () => rootRoute,
	path: "/campaign-description",
	component: CampaignDescriptionPage,
});

export default campaignDescriptionRoute;
